import Base from '../base';

class Lot extends Base {
	getTypes() {
		const api = this._api
			.url('/ref/shipping-types')
			.GET;
		return this.request(api);
	}

	getCompanies() {
		const api = this._api
			.url('/ref/contractors')
			.GET;
		return this.request(api);
	}

	getAddressForShipper(id) {
		const api = this._api
			.url(`/ref/contractors/${id}/warehouses`)
			.GET;
		return this.request(api);
	}

	getVehicles() {
		const api = this._api
			.url('/ref/vehicle-types')
			.GET;
		return this.request(api);
	}

	getVehicleByTypeId(id) {
		const api = this._api
			.url(`/ref/shipping-types/${id}/vehicle-types`)
			.GET;
		return this.request(api);
	}

	getWarehouses() {
		const api = this._api
			.url('/ref/warehouses')
			.GET;
		return this.request(api);
	}

	getCrossings() {
		const api = this._api
			.url('/ref/border-crossings')
			.GET;
		return this.request(api);
	}

	getClearances() {
		const api = this._api
			.url('/ref/customs-clearances')
			.GET;
		return this.request(api);
	}

	getCargoTypes() {
		const api = this._api
			.url('/ref/cargo-types')
			.GET;
		return this.request(api);
	}

	getCurrencies() {
		const api = this._api
			.url('/ref/currencies')
			.GET;
		return this.request(api);
	}

	getContacts() {
		const api = this._api
			.url('/users?role=LOGIST')
			.GET;
		return this.request(api);
	}

	getLastBidOfTK(id) {
		const api = this._api
			.url(`/auction/${id}/bids`)
			.GET;
		return this.request(api);
	}
}

export default new Lot();
